<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters" :collapse-action="true">
        <div class="vx-row">
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">Name</label>
            <vs-input type="search" placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0" />
          </div>
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">Is Shipping Address?</label>
            <v-select
              name="is_shipping_address"
              :clearable="true"
              placeholder="All"
              label="name"
              v-model="filters['is_shipping_address']"
              :reduce="option => option.value"
              :options="booleanOptions"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full mb-4 md:mb-0"
            />
          </div>
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">Is Default Address?</label>
            <v-select
              name="is_default"
              :clearable="true"
              placeholder="All"
              label="name"
              v-model="filters['is_default']"
              :reduce="option => option.value"
              :options="booleanOptions"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full mb-4 md:mb-0"
            />
          </div>
        </div>
        <div class="mt-5 vx-row">
          <div class="w-full ml-auto vx-col">
            <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather" v-on:click="filters = {}">CLEAR</vs-button>
          </div>
        </div>
      </vx-card>

      <vx-card :title="'COMPANY ADDRESSES'" class="">
        <template slot="actions">
          <vs-button v-if="$can('edit-company-address-setting')" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4" color="primary" type="filled">create</vs-button>
        </template>
        <div id="company-addresses-table" class="vx-row">
          <div class="w-full vx-col">
            <vs-table stripe sort class="mt-8" :data="company_addresses" @sort="handleSort" :sst="true">
              <template slot="thead">
                <vs-th sort-key="name" width="18%">NAME</vs-th>
                <vs-th sort-key="line1" width="22%">ADDRESS</vs-th>
                <vs-th sort-key="town_state" width="12%">TOWN / STATE</vs-th>
                <vs-th width="10%">POST CODE</vs-th>
                <vs-th sort-key="country" width="12%">COUNTRY</vs-th>
                <vs-th sort-key="is_shipping_address" width="9%">SHIPPING</vs-th>
                <vs-th sort-key="is_default" width="7%">DEFAULT</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].name">
                    <span class="font-medium">{{ data[indextr].name }}</span>
                  </vs-td>

                  <vs-td :data="data[indextr].line1">
                    <div>{{ data[indextr].line1 }}</div>
                    <div v-if="data[indextr].line2" class="text-xs text-muted">{{ data[indextr].line2 }}</div>
                    <div v-if="data[indextr].line3" class="text-xs text-muted">{{ data[indextr].line3 }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].town_state">
                    {{ data[indextr].town_state }}
                  </vs-td>

                  <vs-td :data="data[indextr].post_code">
                    {{ data[indextr].post_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].country">
                    {{ data[indextr].country }}
                  </vs-td>

                  <vs-td :data="data[indextr].is_shipping_address">
                    <vs-switch
                      v-model="data[indextr].is_shipping_address"
                      :disabled="!$can('edit-company-address-setting')"
                      icon-pack="feather"
                      vs-icon-on="icon-check-circle"
                      vs-icon-off="icon-slash"
                      class="mt-1 w-8"
                      @input="updateAddressSwitch(data[indextr], 'is_shipping_address')"
                    >
                      <span slot="on"></span>
                      <span slot="off"></span>
                    </vs-switch>
                  </vs-td>

                  <vs-td :data="data[indextr].is_default">
                    <vs-switch
                      v-model="data[indextr].is_default"
                      :disabled="!$can('edit-company-address-setting')"
                      icon-pack="feather"
                      vs-icon-on="icon-check-circle"
                      vs-icon-off="icon-slash"
                      class="mt-1 w-8"
                      @input="updateAddressSwitch(data[indextr], 'is_default')"
                    >
                      <span slot="on"></span>
                      <span slot="off"></span>
                    </vs-switch>
                  </vs-td>

                  <vs-td>
                    <div class="justify-start vx-row">
                      <vx-tooltip :text="$can('edit-company-address-setting') ? 'View/Update' : 'View'" position="left">
                        <vs-button
                          @click.stop="onClickUpdate(data[indextr].id)"
                          class="ml-3"
                          size="small"
                          color="warning"
                          type="border"
                          icon-pack="feather"
                          :icon="$can('edit-company-address-setting') ? 'icon-edit-2' : 'icon-eye'"
                        ></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="$can('edit-company-address-setting')" text="Remove" position="left">
                        <vs-button
                          @click.stop="openConfirm(data[indextr].id)"
                          class="ml-3"
                          size="small"
                          color="danger"
                          type="border"
                          icon-pack="feather"
                          icon="icon-trash-2"
                        ></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vx-card>
    </div>
    <add-new-company-address-pop-up
      ref="addNewCompanyAddressPopUp"
      :company-addresses="company_addresses"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewCompanyAddressPopUp from '@/components/popups/settings/company-address/AddNewCompanyAddressPopUp.vue';
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage';
import ErrorMessages from '@/mixins/ErrorMessages';
import vSelect from 'vue-select';

const CompanyAddressRepository = RepositoryFactory.get('company_address');
const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

export default {
  name: 'CompanyAddressSettings',
  components: {
    AddNewCompanyAddressPopUp,
    'v-select': vSelect
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  data() {
    return {
      company_addresses: [],
      countryCodes: [],
      filters: {},
      sort: 'name',
      booleanOptions: [
        { name: 'Yes', value: '1' },
        { name: 'No', value: '0' }
      ]
    };
  },
  methods: {
    async refreshData() {
      await this.fetchCompanyAddresses();
    },
    async fetchCompanyAddresses() {
      await this.$vs.loading({
        container: '#company-addresses-table',
        scale: 0.45
      });
      try {
        const response = await CompanyAddressRepository.getCompanyAddresses(this.filterQuery, this.sort);
        const data = response.data;
        this.company_addresses = Array.isArray(data) ? data : (data.data || []);
      } catch (e) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close('#company-addresses-table > .con-vs-loading');
      }
    },
    filterQueryUpdate() {
      this.fetchCompanyAddresses();
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? '-' : '';
        this.sort = active + key;
        this.fetchCompanyAddresses();
      }
    },
    async onClickAdd() {
      if (!this.$can('edit-company-address-setting')) return;
      await this.$refs.addNewCompanyAddressPopUp.openPopup();
    },
    async onClickUpdate(id) {
      await this.$refs.addNewCompanyAddressPopUp.openPopup(id);
    },
    openConfirm(id) {
      if (!this.$can('edit-company-address-setting')) return;
      const address = this.company_addresses.find(item => String(item.id) === String(id));
      if (address) {
        if (address.is_default) {
          const otherDefaults = this.company_addresses.filter(
            item => String(item.id) !== String(id) && !!item.is_default
          );
          if (otherDefaults.length === 0) {
            this.showWarningMessage('Cannot delete the only default company address. Please set another address as default first.');
            return;
          }
        }
        if (address.is_shipping_address) {
          const otherShippings = this.company_addresses.filter(
            item => String(item.id) !== String(id) && !!item.is_shipping_address
          );
          if (otherShippings.length === 0) {
            this.showWarningMessage('Cannot delete the only shipping company address. Please set another address as shipping address first.');
            return;
          }
        }
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      });
    },
    async onClickDelete(params) {
      if (!this.$can('edit-company-address-setting')) return;
      await this.$vs.loading({
        container: '#company-addresses-table',
        scale: 0.45
      });
      try {
        await CompanyAddressRepository.deleteCompanyAddress(params[0]);
        await this.showSuccessMessage('Company address deleted successfully');
        await this.fetchCompanyAddresses();
      } catch (e) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close('#company-addresses-table > .con-vs-loading');
      }
    },
    async loadCountryCodes() {
      try {
        const res = await SupplierManufactureRepository.getCountryCodes();
        this.countryCodes = (res.data && res.data.data) ? res.data.data : (res.data || []);
      } catch (e) {
        console.error('Failed to load country codes', e);
      }
    },
    getPayload(item) {
      let countryVal = item.country || '';
      if (this.countryCodes && this.countryCodes.length) {
        const match = this.countryCodes.find(
          c => (c.name && c.name.toLowerCase() === (item.country || '').toLowerCase()) ||
               (c.iso_code && c.iso_code.toLowerCase() === (item.country || '').toLowerCase())
        );
        if (match) {
          countryVal = match.iso_code;
        }
      }

      return {
        name: item.name,
        line1: item.line1,
        line2: item.line2 || '',
        line3: item.line3 || '',
        town_state: item.town_state,
        post_code: item.post_code,
        country: countryVal,
        type: item.type || 'company-address',
        is_shipping_address: !!item.is_shipping_address,
        is_default: !!item.is_default,
        note: item.note || ''
      };
    },
    async updateAddressSwitch(data, fieldName) {
      if (!this.$can('edit-company-address-setting')) return;
      if (!data[fieldName]) {
        const otherWithField = this.company_addresses.filter(
          item => String(item.id) !== String(data.id) && !!item[fieldName]
        );
        if (otherWithField.length === 0) {
          data[fieldName] = true;
          this.$nextTick(() => {
            data[fieldName] = true;
          });
          const label = fieldName === 'is_default' ? 'default address' : 'shipping address';
          this.showWarningMessage(`At least one address must be set as ${label}.`);
          return;
        }
      }

      await this.$vs.loading({
        container: '#company-addresses-table',
        scale: 0.45
      });
      try {
        const payload = this.getPayload(data);
        await CompanyAddressRepository.updateCompanyAddress(data.id, payload);
        const label = fieldName === 'is_default' ? 'Default address' : 'Shipping address';
        this.showSuccessMessage(`${label} updated successfully`);
        await this.fetchCompanyAddresses();
      } catch (error) {
        this.convertAndNotifyError(error);
        await this.fetchCompanyAddresses();
      } finally {
        this.$vs.loading.close('#company-addresses-table > .con-vs-loading');
      }
    }
  },
  async mounted() {
    await Promise.all([
      this.loadCountryCodes(),
      this.fetchCompanyAddresses()
    ]);
  }
};
</script>

<style scoped>
</style>
